import { BankAccountsList } from "../components/List/BankAccountsList";
import { BankAccountsCreate } from "../components/Create/BankAccountsCreate";
import { BankAccountsEdit } from "../components/Edit/BankAccountsEdit";
import { BankAccountsView } from "../components/View/BankAccountsView";
import { ContactsOutlined } from "@ant-design/icons";
import { UserRole } from "@root/api.types";
export const BANK_ACCOUNTS_LIST = {
    path: "/admin/bank-accounts",
    component: BankAccountsList,
    roles: [UserRole.ADMIN, UserRole.ACCOUNTANT, UserRole.SHAREHOLDER],
    menu: {
        key: "BANK_ACCOUNTS_LIST",
        label: "management.bank_accounts.menu.title",
        icon: ContactsOutlined,
    },
};
export const BANK_ACCOUNTS_CREATE = {
    path: "/admin/bank-accounts/create",
    roles: [UserRole.ADMIN, UserRole.ACCOUNTANT, UserRole.SHAREHOLDER],
    component: BankAccountsCreate,
};
export const BANK_ACCOUNTS_EDIT = {
    path: "/admin/bank-accounts/:id/edit",
    roles: [UserRole.ADMIN, UserRole.ACCOUNTANT, UserRole.SHAREHOLDER],
    component: BankAccountsEdit,
};
export const BANK_ACCOUNTS_VIEW = {
    path: "/admin/bank-accounts/:id/view",
    roles: [UserRole.ADMIN, UserRole.ACCOUNTANT, UserRole.SHAREHOLDER],
    component: BankAccountsView,
};
